<library-wrapper-component
  [libraryType]="libraryStore.library.type"
  [library]="libraryStore.libraryItems"
  [showItemMenuButtons]="showLibraryItemMenuButtons"
  (onScrollChanged)="onScroll()"
></library-wrapper-component>

<div (click)="minimizeToggle()">
  <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10">
    <path
      fill-rule="evenodd"
      d="M.724 8.948l1.048 1.051 4.993-5.002L1.772-.005.724 1.046l3.944 3.951L.724 8.948z"
    />
  </svg>
</div>
